/* AddEditCredentialRenderer.js */

"use strict";
const ButtonControl = require("@gluenetworks/steve_ui_core").Control.Action.Button;
const InputSelectControl = require("@gluenetworks/steve_ui_core").Control.OptionSelection.Single
    .ComboBox;

const _ = require("lodash");

class AddEditCredentialsRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("add-credentials-veil");
        this._rootElem.component = this._model;

        this._typeField = new InputSelectControl({
            darkTheme: true,
            placeholder: "Type",
            options: [
                {label: "Login", value: "login"},
                {label: "Enable Mode", value: "enableMode"},
            ],
            value: this._model._context.type || "login",
        });

        this._loginSection = document.createElement("div");
        this._loginSection.classList.add("login-block");
        this._loginField = new InputSelectControl({
            darkTheme: true,
            placeholder: "Credential",
            options: this._model._dropdownValues.deviceUserPass,
            required: true,
            value: !_.isEmpty(this._model._dropdownValues.deviceUserPass)
                ? this._model._dropdownValues.deviceUserPass[0].value
                : "",
        });

        this._enableModeSection = document.createElement("div");
        this._enableModeSection.classList.add("enable-mode-block");

        this._enableModeField = new InputSelectControl({
            darkTheme: true,
            placeholder: "Credential",
            options: this._model._dropdownValues.enableMode,
            required: true,
            value: !_.isEmpty(this._model._dropdownValues.enableMode)
                ? this._model._dropdownValues.enableMode[0].value
                : "",
        });

        this._confirmButton = new ButtonControl({
            label: "OK",
            darkTheme: true,
            theme: "additive",
            disabled: true,
            active: true,
        });
        this._cancelButton = new ButtonControl({
            label: "Cancel",
        });
        this._titleComponent = document.createElement("h2");
        this._titleComponent.innerText = this._model._title;

        this._messageBox = document.createElement("p");
        this._messageBox.innerText = this.model.message;

        this._buttonContainer = document.createElement("button-container");

        this._registerListeners();
    }
    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/
    _registerListeners() {
        this._confirmButton.on(
            "UserClick",
            (this._onConfirmButtonClick = this._onConfirmButtonClick.bind(this))
        );
        this._cancelButton.on(
            "UserClick",
            (this._onCancelButtonClick = this._onCancelButtonClick.bind(this))
        );

        this._typeField.on("UserValue", (this.checkTypeValue = this.checkTypeValue.bind(this)));
        this._loginField.on("UserValue", (this.checkLoginValue = this.checkLoginValue.bind(this)));
        this._enableModeField.on(
            "UserValue",
            (this.checkEnableModeValue = this.checkEnableModeValue.bind(this))
        );
    }
    _unregisterListeners() {
        this._confirmButton.removeAllListeners("UserClick");
        this._cancelButton.removeAllListeners("UserClick");
        this._typeField.removeAllListeners("UserValue");
    }

    checkTypeValue() {
        this._showHideSections();
        this.checkValue();
    }

    checkLoginValue() {
        this.checkValue();
    }

    checkEnableModeValue() {
        this.checkValue();
    }

    _onConfirmButtonClick() {
        this._callCreateAction();
    }
    _onCancelButtonClick() {
        this._model.cancelAction();
    }
    _checkForImpliedConfirm(event) {
        if (event.keyCode === 13) {
            if (!_.isEmpty(this._nameField.getValue())) {
                this._callCreateAction();
            }
        }
    }
    checkValue() {
        if (this._typeField.getValue() === "login") {
            this._confirmButton.disabled = _.isEmpty(this._loginField.getValue());
        } else {
            this._confirmButton.disabled = _.isEmpty(this._enableModeField.getValue());
        }
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    shutdown() {
        this._unregisterListeners();
        let promArr = [
            this._typeField.shutdown(),
            this._confirmButton.shutdown(),
            this._cancelButton.shutdown(),
        ];

        return Promise.all(promArr).then(
            () => {
                this._typeField = undefined;
                this._confirmButton = undefined;
                this._buttonContainer.remove();
                this._buttonContainer = undefined;
                this._titleComponent.remove();
                this._titleComponent = undefined;
                this._messageBox.remove();
                this._messageBox = undefined;
                this._model = undefined;
                this._rootElem.remove();
                this._rootElem = undefined;
                this._cancelButton = undefined;
            },
            (err) => {
                this._model.logger.warn(err, "BaseCreateRenderer.shutdown() error");
            }
        );
    }
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        return new Promise((resolve /*,reject*/) => {
            if (!this._rootElem.hasChildNodes()) {
                this._rootElem.appendChild(this._titleComponent);

                this._rootElem.appendChild(
                    this._createSection("Type", this._typeField, "type-container")
                );

                this._loginSection.appendChild(this._createSection("Credential", this._loginField));

                this._enableModeSection.appendChild(
                    this._createSection("Credential", this._enableModeField)
                );

                this._rootElem.appendChild(this._loginSection);
                this._rootElem.appendChild(this._enableModeSection);

                this._buttonContainer.appendChild(this._cancelButton.renderer.rootElement);
                this._buttonContainer.appendChild(this._confirmButton.renderer.rootElement);
                this._rootElem.appendChild(this._buttonContainer);

                if (!_.isEmpty(this._model._context)) {
                    if (this._model._type === "login") {
                        this._typeField.setValue(this._model._type);
                        if (this._model._credential.indexOf("{{credentials.") > -1) {
                            this._loginField.setValue(
                                this._model._credential
                                    .replace("{{credentials.", "")
                                    .replace("}}", "")
                            );
                        } else {
                            this._loginField.setValue(`{{credentials.${this._model._credential}}}`);
                        }
                    } else if (this._model._type === "enableMode") {
                        this._typeField.setValue(this._model._type);
                        if (this._model._enableMode.indexOf("{{credentials.") > -1) {
                            this._enableModeField.setValue(
                                this._model._enableMode
                                    .replace("{{credentials.", "")
                                    .replace("}}", "")
                            );
                        } else {
                            this._enableModeField.setValue(
                                `{{credentials.${this._model._enableMode}}}`
                            );
                        }
                    }
                } else {
                    this.checkValue();
                }

                this._showHideSections();
            }
            return resolve();
        });
    }

    _showHideSections() {
        const selectedSection = this._typeField.getValue();

        switch (selectedSection) {
            case "enableMode":
                this._enableModeSection.classList.remove("hide");
                this._loginSection.classList.add("hide");
                break;
            default:
                this._enableModeSection.classList.add("hide");
                this._loginSection.classList.remove("hide");
                break;
        }
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS          */
    /* START PRIVATE RENDER METHODS            */
    /*******************************************/
    //TODO Private Render Methods here

    _createSection(name, Compnent, className) {
        const section = document.createElement("section");
        const label = document.createElement("label");
        section.className = "key-section";
        if (className) {
            section.classList.add(className);
        }
        label.innerText = name;
        Compnent.setAttribute("rows", "6");
        section.appendChild(label);
        section.appendChild(Compnent.renderer.rootElement);
        return section;
    }

    /*******************************************/
    /* END PRIVATE RENDER METHODS              */
    /* START HANDLER METHODS                   */
    /*******************************************/
    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE API METHODS               */
    /*******************************************/
    _callCreateAction() {
        const type = this._typeField.getValue();
        switch (type) {
            case "login":
                this._model.createAction({
                    type: this._typeField.getValue(),
                    credValue: this._loginField
                        .getValue()
                        .replace("{{credentials.", "")
                        .replace("}}", ""),
                });
                break;
            default:
                this._model.createAction({
                    type: this._typeField.getValue(),
                    credValue: this._enableModeField
                        .getValue()
                        .replace("{{credentials.", "")
                        .replace("}}", ""),
                });
                break;
        }
    }

    /*******************************************/
    /*  END PRIVATE API METHODS                */
    /*******************************************/
}
module.exports = AddEditCredentialsRenderer;
